import { IdSvrAuthService } from "../../auth/idSrvAuthService";
import { DateService } from "@topline/services/dateService";
import { MarketEditService } from "./services/marketEditService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";
    module.controller("marketEditController", [
        "market",
        "editable",
        "meetsRequirements",
        "$scope",
        "$state",
        MarketEditService.componentName,
        "marketDefinitionService",
        IdSvrAuthService.componentName,
        "AlertService",
        "modalService",
        angularServicesNames.$translate,
        DateService.componentName,
        MarketEditController
    ]);

    function MarketEditController(
        this: $TSFixMe,
        market: $TSFixMe,
        editable: $TSFixMe,
        meetsRequirements: $TSFixMe,
        $scope: $TSFixMe,
        $state: ng.ui.IStateService,
        marketEditService: MarketEditService,
        marketDefinitionService: $TSFixMe,
        authService: IdSvrAuthService,
        AlertService: AlertService,
        modalService: $TSFixMe,
        $translate: ng.translate.ITranslateService,
        dateService: DateService
    ) {
        var $ctrl = this;

        $scope.market = market;
        $scope.source = "marketSource";

        $ctrl.canEdit = editable.isEditable == 1;
        $ctrl.canClone = editable.isCloneable == 1;
        $ctrl.marketNameFromDictionary = [];
        authService.hasPermissionAsync("ProductManager").then(result => $scope.isProductManager = result);
        authService.hasPermissionAsync("SetMarketAsFinished").then(result => $ctrl.canFinishMarket = result);
        authService.hasPermissionAsync("AddProductsToFinishedMarkets").then(result => $ctrl.canAddProductsToFinishedMarkets = result);
        $ctrl.saveInProgress = false;
        $ctrl.saveAndFinishInProgress = false;

        $ctrl.meetsRequirementsCheckResult = meetsRequirements;

        if ($scope.market && $scope.market.budgetYear == null) {
            $scope.market.budgetYear = dateService.getDefaultBudgetYear();
        }

        $ctrl.readOnly = !$scope.market || !$scope.market.isCreatedByMy || !$ctrl.canEdit;
        $ctrl.readOnlyNewProducts = () => $ctrl.readOnly && !$ctrl.canAddProductsToFinishedMarkets;

        if (!$ctrl.canEdit && $scope.market.isCreatedByMy && $ctrl.canClone) {
            AlertService.warning($translate.instant("MARKET.READONLY_MODE"));
        }

        $ctrl.isNewMarket = function () {
            return !$scope.market || $scope.market.name == null;
        };

        $scope.marketNameSetArgs = function (val: $TSFixMe) {
            return {
                value: val
            };
        };

        $scope.removeMarket = function () {
            if (!$ctrl.canEdit) {
                AlertService.warning($translate.instant("MARKET.READONLY_MODE"));
                return;
            }

            modalService.showConfirmationModal(
                {
                    text: "MARKET.REMOVE_CONFIRM",
                    title: "MARKET.REMOVE_CONFIRM_TITLE"
                },
                () => {
                    marketEditService.delete($scope.market.id)
                        .then(function () {
                            $state.go("market.list");
                            AlertService.success($translate.instant("MARKET.REMOVE_SUCCESS"));
                        })
                        .catch(() => {
                            AlertService.error($translate.instant("MARKET.REMOVE_ERROR"));
                        });
                },
                null,
                "danger"
            );
        };

        const updateMetRequirements = () => {
            marketEditService.checkIMSMarketRequirements($scope.market.filters, $scope.market.kamsoftMarketType).then(
                (checkResult: $TSFixMe) => {
                    $ctrl.meetsRequirementsCheckResult = checkResult;
                }
            );
        };

        $ctrl.addFilter = (filter: $TSFixMe) => {
            var index = $scope.market.filters.findIndex((f: $TSFixMe) => isFilterEqual(filter, f));
            if (index < 0) {

                $scope.market.filters.push(angular.copy(filter));
                updateMetRequirements();
            }
        };

        $ctrl.removeFilter = (data: $TSFixMe) => {
            var index = $scope.market.filters.findIndex((f: $TSFixMe) => isFilterEqual(data, f));
            if (index > -1) {
                $scope.market.filters.splice(index, 1);
                updateMetRequirements();
            }
        };

        $ctrl.getRequirementsErrorMessage = () => {
            const checkResult = $ctrl.meetsRequirementsCheckResult;

            if (!checkResult) return "";

            const hasTwoCompetitors = !checkResult.hasTwoCompetitors
                ? $translate.instant("MARKET.HAS_TWO_COMPETITORS_REQUIREMENT_ERROR")
                : "";
            const hasAdamedProducts = !checkResult.hasAdamedProducts
                ? $translate.instant("MARKET.HAS_ADAMED_PRODUCTS_REQUIREMENT_ERROR")
                : "";
            const satisfiesKamsoftMarketType = !checkResult.satisfiesMarketType
                ? $translate.instant("MARKET.MARKET_TYPE_REQUIREMENT_ERROR")
                : "";

            return [hasTwoCompetitors, hasAdamedProducts, satisfiesKamsoftMarketType].filter(x => x !== "").join(" ");
        };

        $ctrl.onKamsoftMarketTypeChange = () => {
            $scope.market.similarNeeds = undefined;
        };

        function isFilterEqual(f1: $TSFixMe, f2: $TSFixMe) {
            return (
                f1.pharmacyMarket === f2.pharmacyMarket &&
                f1.perscirptionMarket === f1.perscirptionMarket &&
                f1.atc3 === f2.atc3 &&
                f1.atc4 === f2.atc4 &&
                
                _.isEqual(f1.nfc3, f2.nfc3) &&
                
                _.isEqual(f1.molecules, f2.molecules) &&
                f1.brand === f2.brand &&
                f1.moleculeType === f2.moleculeType &&
                f1.type === f2.type &&
                f1.sku === f2.sku &&
                f1.onlySelectedMolecues === f2.onlySelectedMolecues
            );
        }

        const saveMarket = function () {
            $ctrl.saveInProgress = true;
            $scope.serverOperation = marketEditService.save($scope.market).then(function () {
                $state.go("market.list");
                $ctrl.saveInProgress = false;
            });
        };

        const saveAndFinishMarket = function () {
            $ctrl.saveAndFinishInProgress = true;
            $scope.serverOperation = marketEditService.saveAndFinish($scope.market, "ims").then(function (response: $TSFixMe) {
                if (response.status != HttpStatus.OK && response.status != 204) {
                    marketEditService.displaySaveMarketError(
                        response,
                        Object.assign({}, $scope.market, { ["type"]: "Ims" })
                    );
                    $ctrl.saveAndFinishInProgress = false;
                }
                $state.go("market.list");
            });
        };

        const getRequirementsModalErrorMessage = () => {
            const message = $ctrl.getRequirementsErrorMessage();
            const ending = $translate.instant("MARKET.REQUIREMENT_ERROR");

            return `${message} ${ending}`;
        };

        const showRequirementsWarningModal = (onAccept: $TSFixMe) => modalService.showConfirmationModalStr(
            {
                text: getRequirementsModalErrorMessage(),
                title: $translate.instant("MARKET.HAS_REQUIREMENT_ERRORS_TITLE"),
                okText: $translate.instant("SAVE")
            },
            onAccept,
            null,
            "warning"
        );

        const showRequirementsErrorModal = () =>
            modalService.showErrorModalStr({
                text: getRequirementsModalErrorMessage(),
                title: $translate.instant("MARKET.HAS_REQUIREMENT_ERRORS_TITLE")
            });

        $scope.actions = {
            save: () => {
                if ($scope.marketForm.$valid) {
                    $ctrl.saveInProgress = true;
                    marketEditService.checkIMSMarketRequirements(
                        $scope.market.filters,
                        $scope.market.kamsoftMarketType
                    ).then((checkResult: $TSFixMe) => {
                        $ctrl.meetsRequirementsCheckResult = checkResult;
                        if (checkResult.hasErrors) {
                            $ctrl.saveInProgress = false;
                            checkResult.satisfiesMarketType
                                ? showRequirementsWarningModal(saveMarket)
                                : showRequirementsErrorModal();
                        } else {
                            saveMarket();
                        }
                    });
                } else {

                    const $elm = angular
                        .element("[name='" + $scope.marketForm.$name + "']")
                        .find(".ng-invalid:visible:first")
                        .first();
                    // @ts-expect-error ts-migrate(2581) FIXME: Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
                    $("html,body").animate({ scrollTop: $elm.offset().top }, "slow");
                }

                $scope.marketForm.$submitted = true;
            },
            saveNewProducts: () => {
                if ($scope.marketForm.$valid) {
                    $scope.serverOperation = marketEditService.saveNewProducts($scope.market).then(function (response: $TSFixMe) {
                        $state.go("market.list");
                    });
                } else {

                    const $elm = angular
                        .element("[name='" + $scope.marketForm.$name + "']")
                        .find(".ng-invalid:visible:first")
                        .first();
                    // @ts-expect-error ts-migrate(2581) FIXME: Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
                    $("html,body").animate({ scrollTop: $elm.offset().top }, "slow");
                }

                $scope.marketForm.$submitted = true;
            },
            saveAndFinish: () => {
                if ($scope.marketForm.$valid) {
                    $ctrl.saveAndFinishInProgress = true;
                    marketEditService.checkIMSMarketRequirements(
                        $scope.market.filters,
                        $scope.market.kamsoftMarketType
                    ).then((checkResult: $TSFixMe) => {
                        $ctrl.meetsRequirementsCheckResult = checkResult;
                        if (checkResult.hasErrors) {
                            $ctrl.saveAndFinishInProgress = false;
                            checkResult.satisfiesMarketType
                                ? showRequirementsWarningModal(saveAndFinishMarket)
                                : showRequirementsErrorModal();
                        } else {
                            saveAndFinishMarket();
                        }
                    });
                } else {

                    const $elm = angular
                        .element("[name='" + $scope.marketForm.$name + "']")
                        .find(".ng-invalid:visible:first")
                        .first();
                    // @ts-expect-error ts-migrate(2581) FIXME: Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
                    $("html,body").animate({ scrollTop: $elm.offset().top }, "slow");
                }

                $scope.marketForm.$submitted = true;
            }
        };

        marketDefinitionService.getActive().then((marketDefinitions: $TSFixMe) => $ctrl.marketDefinitions = marketDefinitions);
        marketEditService.getSimilarNeeds().then(
            (similarNeeds: $TSFixMe) => $ctrl.similarNeeds = similarNeeds.map((sn: $TSFixMe) => sn.name)
        );
    }

})(angular.module("topline.modules"));
